import { getRecruitmentCoverTypeMap } from '../../constants';
import { BI_COW_COVER, BUSINESS_INTERUPTION, CMR_COVER, COMPUTER_BREAKDOWN_COVER, DEBRIS_REMOVAL_COVER, DEDUCTIBLE_COVER, DIRECTORS_OFFICERS_COVER, DRIVERS_NEGLIGENCE, DRIVERS_NEGLIGENCE_SWITCH, EARNED_FREIGHT_COVER, EMPLOYERS_LIABILITY, EMPLOYMENT_PRACTICES_COVER, EMPLOYMENT_PRACTICES_COVER_SWITCH, FIDELITY_CRIME, FIDELITY_CRIME_SWITCH, FIRE_DEPARTMENT_COVER, GOODS_IN_TRANSIT, LOSS_DATA_COVER, MONEY_ASSAULT_COVER, NON_OWNED_TRAILER, OWNERS_GOODS_EXTENSION, POLLUTANT_CLEAN_UP, PORTABLE_EQUIPMENT, PORTABLE_EQUIPMENT_COVER, PRE_POWER_UNIT_COVER, PROFESSIONAL_INDEMNITY, PROPERTY_COVER, PROPERTY_COVER_TYPE_LIST, PUBLIC_LIABILITY, REFRIGERATION_BREAKDOWN, RELOADING_COVER, REUSABLE_PACKING_CONTAINERS, REWARD_COVERAGE_COVER, TARPS_CHAINS } from '../../constants/coverage';
import { PROVIDER_SOURCE } from '../../constants/quote';
import { getCoverInfoMap, getCoverInfoMapWithExtraConfig, getGreateAmericanCoverList, getGreateAmericanCoverMap } from '../../localeConstants';
import { getCurrencySymbol } from '../../shared/formatters';
export var useQuoteCoverage = function useQuoteCoverage() {
  var filterInsuranceCurrentSelectCoverageList = function filterInsuranceCurrentSelectCoverageList(selectCoverageInfo, config) {
    var filterList = [];
    var notFilter = config.notFilter,
        coverType = config.coverType,
        providerCode = config.providerCode;

    switch (providerCode) {
      case PROVIDER_SOURCE().GREATEAMERICAN.value:
        filterList = [];
        [{
          priceKey: PRE_POWER_UNIT_COVER,
          infoKey: PRE_POWER_UNIT_COVER
        }, {
          priceKey: DEDUCTIBLE_COVER,
          infoKey: DEDUCTIBLE_COVER
        }, {
          priceKey: RELOADING_COVER,
          infoKey: RELOADING_COVER
        }, {
          priceKey: DEBRIS_REMOVAL_COVER,
          infoKey: DEBRIS_REMOVAL_COVER
        }, {
          priceKey: EARNED_FREIGHT_COVER,
          infoKey: EARNED_FREIGHT_COVER
        }, {
          priceKey: FIRE_DEPARTMENT_COVER,
          infoKey: FIRE_DEPARTMENT_COVER
        }, {
          priceKey: LOSS_DATA_COVER,
          infoKey: LOSS_DATA_COVER
        }, {
          priceKey: REWARD_COVERAGE_COVER,
          infoKey: REWARD_COVERAGE_COVER
        }, {
          priceKey: POLLUTANT_CLEAN_UP,
          infoKey: POLLUTANT_CLEAN_UP
        }, {
          priceKey: REFRIGERATION_BREAKDOWN,
          infoKey: REFRIGERATION_BREAKDOWN
        }, {
          priceKey: OWNERS_GOODS_EXTENSION,
          infoKey: OWNERS_GOODS_EXTENSION
        }, {
          priceKey: NON_OWNED_TRAILER,
          infoKey: NON_OWNED_TRAILER
        }, {
          priceKey: REUSABLE_PACKING_CONTAINERS,
          infoKey: REUSABLE_PACKING_CONTAINERS
        }, {
          priceKey: TARPS_CHAINS,
          infoKey: TARPS_CHAINS
        }].forEach(function (item) {
          if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[item.priceKey])) {
            filterList.push(getCoverInfoMap()[item.infoKey].value);
          }
        });
        break;

      case PROVIDER_SOURCE().ACCELERANT.value:
        filterList = [];
        [{
          priceKey: PROFESSIONAL_INDEMNITY,
          infoKey: PROFESSIONAL_INDEMNITY
        }, {
          priceKey: FIDELITY_CRIME_SWITCH,
          infoKey: FIDELITY_CRIME
        }, {
          priceKey: PUBLIC_LIABILITY,
          infoKey: PUBLIC_LIABILITY
        }, {
          priceKey: EMPLOYERS_LIABILITY,
          infoKey: EMPLOYERS_LIABILITY
        }, {
          priceKey: DIRECTORS_OFFICERS_COVER,
          infoKey: DIRECTORS_OFFICERS_COVER
        }].forEach(function (item) {
          if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[item.priceKey])) {
            filterList.push(getCoverInfoMap()[item.infoKey].value);
          }
        });

        if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[EMPLOYMENT_PRACTICES_COVER_SWITCH]) && !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[EMPLOYMENT_PRACTICES_COVER])) {
          filterList.push(getCoverInfoMap()[EMPLOYMENT_PRACTICES_COVER].value);
        }

        if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[PROPERTY_COVER])) {
          filterList.push(getCoverInfoMap()[PROPERTY_COVER_TYPE_LIST].value);
        }

        if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[BUSINESS_INTERUPTION])) {
          filterList.push(getCoverInfoMap()[BI_COW_COVER].value);
        }

        if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[PORTABLE_EQUIPMENT_COVER])) {
          filterList.push(getCoverInfoMap()[PORTABLE_EQUIPMENT].value);
        }

        if (coverType === getRecruitmentCoverTypeMap()["package"].value) {
          [{
            priceKey: COMPUTER_BREAKDOWN_COVER,
            infoKey: COMPUTER_BREAKDOWN_COVER
          }, {
            priceKey: MONEY_ASSAULT_COVER,
            infoKey: MONEY_ASSAULT_COVER
          }].forEach(function (item) {
            if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[item.priceKey])) {
              filterList.push(getCoverInfoMap()[item.infoKey].value);
            }
          });
        }

        break;

      case PROVIDER_SOURCE().RECRUITMENT.value:
        filterList = [];
        [{
          priceKey: PROFESSIONAL_INDEMNITY,
          infoKey: PROFESSIONAL_INDEMNITY
        }, {
          priceKey: FIDELITY_CRIME_SWITCH,
          infoKey: FIDELITY_CRIME
        }, {
          priceKey: PUBLIC_LIABILITY,
          infoKey: PUBLIC_LIABILITY
        }].forEach(function (item) {
          if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[item.priceKey])) {
            filterList.push(getCoverInfoMap()[item.infoKey].value);
          }
        });

        if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[DRIVERS_NEGLIGENCE_SWITCH]) && !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[DRIVERS_NEGLIGENCE])) {
          filterList.push(getCoverInfoMap()[DRIVERS_NEGLIGENCE].value);
        }

        [{
          priceKey: EMPLOYERS_LIABILITY,
          infoKey: EMPLOYERS_LIABILITY
        }, {
          priceKey: DIRECTORS_OFFICERS_COVER,
          infoKey: DIRECTORS_OFFICERS_COVER
        }, {
          priceKey: EMPLOYMENT_PRACTICES_COVER_SWITCH,
          infoKey: EMPLOYMENT_PRACTICES_COVER
        }].forEach(function (item) {
          if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[item.priceKey])) {
            filterList.push(getCoverInfoMap()[item.infoKey].value);
          }
        });

        if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[PROPERTY_COVER])) {
          filterList.push(getCoverInfoMap()[PROPERTY_COVER_TYPE_LIST].value);
        }

        if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[BUSINESS_INTERUPTION])) {
          filterList.push(getCoverInfoMap()[BI_COW_COVER].value);
        }

        if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[PORTABLE_EQUIPMENT_COVER])) {
          filterList.push(getCoverInfoMap()[PORTABLE_EQUIPMENT].value);
        }

        if (!!notFilter || coverType === getRecruitmentCoverTypeMap()["package"].value) {
          [{
            priceKey: COMPUTER_BREAKDOWN_COVER,
            infoKey: COMPUTER_BREAKDOWN_COVER
          }, {
            priceKey: MONEY_ASSAULT_COVER,
            infoKey: MONEY_ASSAULT_COVER
          }].forEach(function (item) {
            if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[item.priceKey])) {
              filterList.push(getCoverInfoMap()[item.infoKey].value);
            }
          });
        }

        break;

      case PROVIDER_SOURCE().ACCELERANT_GIT.value:
        filterList = [];
        [{
          priceKey: GOODS_IN_TRANSIT,
          infoKey: GOODS_IN_TRANSIT
        }, {
          priceKey: CMR_COVER,
          infoKey: CMR_COVER
        }, {
          priceKey: PUBLIC_LIABILITY,
          infoKey: PUBLIC_LIABILITY
        }, {
          priceKey: EMPLOYERS_LIABILITY,
          infoKey: EMPLOYERS_LIABILITY
        }].forEach(function (item) {
          if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[item.priceKey])) {
            filterList.push(getCoverInfoMap()[item.infoKey].value);
          }
        });
        break;

      case PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value:
        filterList = [];
        [{
          priceKey: PROFESSIONAL_INDEMNITY,
          infoKey: PROFESSIONAL_INDEMNITY
        }, {
          priceKey: PUBLIC_LIABILITY,
          infoKey: PUBLIC_LIABILITY
        }].forEach(function (item) {
          if (!!notFilter || !!(selectCoverageInfo !== null && selectCoverageInfo !== void 0 && selectCoverageInfo[item.priceKey])) {
            filterList.push(getCoverInfoMap()[item.infoKey].value);
          }
        });
        break;

      default:
        break;
    }

    return filterList;
  };

  var getInsuranceCoverageDetailInfoList = function getInsuranceCoverageDetailInfoList(coverageKeyList, priceInfo, config) {
    var provider_code = priceInfo.provider_code,
        covers = priceInfo.covers,
        covers_options = priceInfo.covers_options,
        currency = priceInfo.currency;

    var _ref = config || {},
        country = _ref.country,
        providerCode = _ref.providerCode;

    var list = [];
    var coverPriceMapKey = (config === null || config === void 0 ? void 0 : config.pricePriceKey) || 'aggregate_covers_price'; // Universal handler

    coverageKeyList.forEach(function (key) {
      var _covers_options$key, _getGreateAmericanCov, _getCoverInfoMapWithE, _priceInfo$coverPrice, _priceInfo$coverPrice2;

      var levelItem = covers_options === null || covers_options === void 0 ? void 0 : (_covers_options$key = covers_options[key]) === null || _covers_options$key === void 0 ? void 0 : _covers_options$key.find(function (item) {
        return item.value === covers[key];
      });
      var tempItem = {
        value: key,
        label: [PROVIDER_SOURCE().GREATEAMERICAN.value].includes(provider_code) ? (_getGreateAmericanCov = getGreateAmericanCoverList().find(function (aItem) {
          return aItem.value === key;
        })) === null || _getGreateAmericanCov === void 0 ? void 0 : _getGreateAmericanCov.label : (_getCoverInfoMapWithE = getCoverInfoMapWithExtraConfig({
          countryCode: country,
          provideCode: providerCode
        })[key]) === null || _getCoverInfoMapWithE === void 0 ? void 0 : _getCoverInfoMapWithE.label,
        price: (priceInfo === null || priceInfo === void 0 ? void 0 : (_priceInfo$coverPrice = priceInfo[coverPriceMapKey]) === null || _priceInfo$coverPrice === void 0 ? void 0 : (_priceInfo$coverPrice2 = _priceInfo$coverPrice[key]) === null || _priceInfo$coverPrice2 === void 0 ? void 0 : _priceInfo$coverPrice2.price) || 0,
        coverLevel: (levelItem === null || levelItem === void 0 ? void 0 : levelItem.label) || 'Included',
        currencyText: getCurrencySymbol(currency),
        coverage: (levelItem === null || levelItem === void 0 ? void 0 : levelItem.value) || 0
      };
      tempItem.title = tempItem.label;
      tempItem.content = tempItem.coverLevel;
      list.push(tempItem);
    });

    switch (provider_code) {
      case PROVIDER_SOURCE().GREATEAMERICAN.value:
        var specialHandlerKeyMap = [{
          originKey: getGreateAmericanCoverMap().nonOwnedTrailer.value,
          handlerKey: getGreateAmericanCoverMap().nonOwnedTrailerLimit.value
        }, {
          originKey: getGreateAmericanCoverMap().reusablePackingContainers.value,
          handlerKey: getGreateAmericanCoverMap().reusablePackingContainersLimit.value
        }, {
          originKey: getGreateAmericanCoverMap().tarpsChains.value,
          handlerKey: getGreateAmericanCoverMap().tarpsChainsLimit.value
        }];
        specialHandlerKeyMap.forEach(function (item) {
          list.forEach(function (aItem) {
            if (aItem.value === item.originKey) {
              var _covers_options$item$;

              var levelItem = covers_options === null || covers_options === void 0 ? void 0 : (_covers_options$item$ = covers_options[item.handlerKey]) === null || _covers_options$item$ === void 0 ? void 0 : _covers_options$item$.find(function (cItem) {
                return cItem.value === covers[item.handlerKey];
              });
              aItem.coverLevel = (levelItem === null || levelItem === void 0 ? void 0 : levelItem.label) || 'Included';
            }
          });
        });
        break;

      default:
        break;
    }

    return list;
  };

  return {
    filterInsuranceCurrentSelectCoverageList: filterInsuranceCurrentSelectCoverageList,
    getInsuranceCoverageDetailInfoList: getInsuranceCoverageDetailInfoList
  };
};